<template>
  <el-form
    label-width="100px"
    class="head_formBox glo_formBox"
    :rules="rules"
    ref="form"
    :model="form"
  >
    <el-form-item prop="number" label="库区编号">
      <el-input v-model="form.number"></el-input>
    </el-form-item>
    <el-form-item prop="cargoareaName" label="库区名称">
      <el-input v-model="form.cargoareaName"></el-input>
    </el-form-item>
    <el-form-item prop="storageId" label="归属网点仓库">
      <el-select v-model="form.storageId" filterable>
        <el-option
          v-for="dept in businessDepts"
          :key="dept.deptId"
          :label="dept.deptName"
          :value="dept.deptId"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="status" label="启用状态">
      <el-select v-model="form.status">
        <el-option :value="1" label="启用"></el-option>
        <el-option :value="0" label="禁用"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="sort" label="排序">
      <el-input v-model="form.sort"></el-input>
    </el-form-item>
    <el-form-item prop="comment" label="备注" class="dislogFormTextarea">
      <el-input v-model="form.comment" type="textarea"></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    cargoareaId: {},
  },
  data() {
    return {
      form: {
        id: "",
        number: "",
        cargoareaName: "",
        storageId: "",
        status: 1,
        sort: "",
        comment: "",
      },
      businessDepts: [],
      rules: {
        cargoareaName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["change", "blur"],
          },
        ],
        storageId: [
          {
            required: true,
            message: "请选择仓库",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  watch: {
    cargoareaId: {
      deep: true,
      immediate: true,
      handler(val) {
        this.form.id = val;
        console.log(val);
        this.getDetail();
      },
    },
  },
  created() {
    this.getBusinessDepts();
  },
  methods: {
    getDetail() {
      if (!this.form.id) {
        return;
      }
      this.$API
        .runList({
          number: "admin_storage_cargo_area_list_v5",
          id: this.form.id,
        })
        .then((res) => {
          this.form = {
            ...res[0],
          };
        })
        .catch((err) => {});
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    async validate() {
      const res = await this.$refs.form.validate();
      return res;
    },
    save() {
      return new Promise(async (resolve, reject) => {
        const valid = await this.validate();
        if (valid) {
          this.$API
            .editCargoarea({
              ...this.form,
            })
            .then((res) => {
              resolve();
              this.clear()
            })
            .catch((err) => {
              reject();
            });
        } else {
          reject();
        }
      });
    },
    reset(){
        this.form = {}
        this.$refs.form.clearValidate()
    }
  },
};
</script>

<style lang="less" scoped>
.dislogFormTextarea {
  min-width: 360px;
  width: 100%;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-right: 3%;
  height: auto;

  /deep/ .el-textarea__inner {
    border: 0;
  }
  /deep/ .el-form-item__content {
    height: auto;
  }
}
</style>